module.exports = __webpack_public_path__ + "img/photo-ci.32f7c395.jpg";